import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { buildingInfo, FloorInfo, ImageBuildings, ImageFloors, ParkingLocationDetail } from '../../../../../../core/models/parking-center/parking-center.model';
import { CookieService } from 'ngx-cookie-service';
import { image } from 'html2canvas/dist/types/css/types/image';
import { LanguageService } from '../../../../../../core/services/language.service';
import { Router } from '@angular/router';
import { LoaderComponent } from "../../../../../style/loader/loader.component";
import { Providers } from '../../../../../../core/models/information.model';
import { ToastNotifService } from '../../../../../../core/services/toastNotif.service';
import { ToastWarnComponent } from "../../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../../tools/template/toast/toast-success/toast-success.component";
import { ApiProviderService } from '../../../../../../core/services/api/Parking/api-provider';
import { ApiParkingCenterService } from '../../../../../../core/services/api/Parking-center/api-parking-center';
import { ApiSitePublicService } from '../../../../../../core/services/api/SitePublic/api-site-public';
import { SitePublicProfileDetail } from '../../../../../../core/models/site-public-profile.model';
import { ImageViewerComponent } from '../../../../../../shared/components/image-viewer/image-viewer.component';
import { SiteAmenitiesComponent } from '../../../../../../shared/components/site-amenities/site-amenities.component';
@Component({
  selector: 'app-modal-google-map',
  imports: [CommonModule, LoaderComponent, ToastWarnComponent, ToastFailedComponent, ToastSuccessComponent, ImageViewerComponent, SiteAmenitiesComponent],
  templateUrl: './modal-google-map.component.html',
  styleUrl: './modal-google-map.component.css'
})
export class ModalGoogleMapComponent {
  @Input() siteId!: number;
  @Input() name!: string;
  @Input() position!: google.maps.LatLngLiteral;
  @Input() available!: number;
  @Input() distance!: number;
  @Input() price!: number;
  @Input() publicRef: string | null = null;
  @Output() closed = new EventEmitter<void>();



  // Data
  listBuilding: ParkingLocationDetail = {} as ParkingLocationDetail;
  // {
  //   siteId: 1,
  //   buildingInfo: [
  //     {
  //       buildingId: 1,
  //       buildingName: 'Building 1',
  //       imagesBuildings: [
  //         { images_building: './images/parking_floor.jpg' },
  //         { images_building: './images/parking_floor_2.jpg' }
  //       ] as unknown as ImageBuildings[],
  //       floors: [
  //         {
  //           floorId: 1,
  //           floorName: 1,
  //           imagesFloors: [
  //             { images_floor: './images/parking_floor.jpg' },
  //             { images_floor: './images/parking_floor_2.jpg' }
  //           ] as unknown as ImageFloors[],
  //           zoneInfos: [
  //               {
  //                 zoneId: 1,
  //                 zoneName: 'Zone A',
  //                 parkingTypeId: 1,
  //                 parkingTypeName: 'Motorcycle',
  //                 vehicleTypeId: 0,
  //                 vehicleTypeName: '',
  //                 parkingSlot: 36,
  //                 availableSlot: 12,
  //               },
  //               {
  //                 zoneId: 2,
  //                 zoneName: 'Zone B',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 1,
  //                 vehicleTypeName: 'Car',
  //                 parkingSlot: 20,
  //                 availableSlot: 10
  //               },
  //               {
  //                 zoneId: 3,
  //                 zoneName: 'Zone C',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 2,
  //                 vehicleTypeName: 'EV',
  //                 parkingSlot: 20,
  //                 availableSlot: 10
  //               }
  //           ]
  //         },
  //         {
  //           floorId: 2,
  //           floorName: 2,
  //           imagesFloors: [
  //             { images_floor: './images/parking_floor.jpg' },
  //             { images_floor: './images/parking_floor_2.jpg' }
  //           ] as unknown as ImageFloors[],
  //           zoneInfos: [
  //               {
  //                 zoneId: 1,
  //                 zoneName: 'Zone A',
  //                 parkingTypeId: 1,
  //                 parkingTypeName: 'Motorcycle',
  //                 vehicleTypeId: 0,
  //                 vehicleTypeName: '',
  //                 parkingSlot: 10,
  //                 availableSlot: 2,
  //               },
  //               {
  //                 zoneId: 2,
  //                 zoneName: 'Zone B',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 1,
  //                 vehicleTypeName: 'Car',
  //                 parkingSlot: 25,
  //                 availableSlot: 5
  //               },
  //               {
  //                 zoneId: 3,
  //                 zoneName: 'Zone C',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 2,
  //                 vehicleTypeName: 'EV',
  //                 parkingSlot: 5,
  //                 availableSlot: 2
  //               }
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       buildingId: 2,
  //         buildingName: 'Building 2',
  //         imagesBuildings: [
  //           { images_building: './images/parking_floor.jpg' },
  //           { images_building: './images/parking_floor_2.jpg' }
  //         ] as unknown as ImageBuildings[],
  //         floors: [
  //           {
  //             floorId: 1,
  //             floorName: 1,
  //             imagesFloors: [
  //               { images_floor: './images/parking_floor.jpg' },
  //               { images_floor: './images/parking_floor_2.jpg' }
  //             ] as unknown as ImageFloors[],
  //             zoneInfos: [
  //               {
  //                 zoneId: 1,
  //                 zoneName: 'Zone A',
  //                 parkingTypeId: 1,
  //                 parkingTypeName: 'Motorcycle',
  //                 vehicleTypeId: 0,
  //                 vehicleTypeName: '',
  //                 parkingSlot: 0,
  //                 availableSlot: 0,
  //               },
  //               {
  //                 zoneId: 2,
  //                 zoneName: 'Zone B',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 1,
  //                 vehicleTypeName: 'Car',
  //                 parkingSlot: 20,
  //                 availableSlot: 8
  //               },
  //               {
  //                 zoneId: 3,
  //                 zoneName: 'Zone C',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 2,
  //                 vehicleTypeName: 'EV',
  //                 parkingSlot: 5,
  //                 availableSlot: 3
  //               }
  //             ],
  //           },
  //           {
  //             floorId: 2,
  //             floorName: 2,
  //             imagesFloors: [
  //               { images_floor: './images/parking_floor.jpg' },
  //               { images_floor: './images/parking_floor_2.jpg' }
  //             ] as unknown as ImageFloors[],
  //             zoneInfos: [
  //               {
  //                 zoneId: 1,
  //                 zoneName: 'Zone A',
  //                 parkingTypeId: 1,
  //                 parkingTypeName: 'Motorcycle',
  //                 vehicleTypeId: 0,
  //                 vehicleTypeName: '',
  //                 parkingSlot: 12,
  //                 availableSlot: 4,
  //               },
  //               {
  //                 zoneId: 2,
  //                 zoneName: 'Zone B',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 1,
  //                 vehicleTypeName: 'Car',
  //                 parkingSlot: 10,
  //                 availableSlot: 5
  //               },
  //               {
  //                 zoneId: 3,
  //                 zoneName: 'Zone C',
  //                 parkingTypeId: 2,
  //                 parkingTypeName: 'Car',
  //                 vehicleTypeId: 2,
  //                 vehicleTypeName: 'EV',
  //                 parkingSlot: 0,
  //                 availableSlot: 0
  //               }
  //             ]
  //           }
  //       ]
  //     }
  //   ],

  //   lat: 0,
  //   lng: 0,
  //   name: 'PSS GROUP',
  //   price_motorcycle: 80,
  //   price_car: 100,
  //   timeIn: new Date(),
  //   timeOut: new Date(new Date().setHours(new Date().getHours() + 8)),
  //   address: '',
  //   logo: '',
  // };

  rating: number = 0;

  carBuildingAvailable: any = null;
  evBuildingAvailable: any = null;
  motorcycleBuildingAvailable: any = null;
  filterBuildingFloorList: any | null = null;
  filteredBuildingList: any | null = null;
  tableBuildingParking: any | null = null;
  allBuildingsParking: number = 0;
  allBuildingsParkingAvailable: number = 0;
  allFloorsParking: any | null = null;
  allFloorsParkingAvailable: any | null = null;
  allBuildingFloorParking: number = 0;
  allBuildingEvParking: number = 0;
  allBuildingCarParking: number = 0;
  allBuildingMotorcycleParking: number = 0;


  // Image
  imageBuildingList: string[] = [];
  imageFloorList: string[] = [];

  // Service
  statusOpen = false;

  // Language
  currentLanguage: 'TH' | 'EN' = 'TH';

  // Token
  token = '';

  // Style
  activeIndex = -1;
  selectBuilding: number = 0;

  imageExpand_buildings: boolean = false;
  currentImageIndex_building: number = 0;

  imageExpand_floors: boolean = false;
  currentImageIndex_floor: number = 0;

  isModalRecommend: boolean = false;

  isLoading: boolean = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  // ตัวแปรสำหรับจัดการ Animation การลาก
  dragStartY: number = 0;
  dragCurrentY: number = 0;
  isDragging: boolean = false;
  modalTransform: string = '';
  modalTransition: string = 'transform 0.3s ease-out'; // Animation ตอนปล่อยมือ

  constructor(
    private apiProviderService: ApiProviderService,
    private apiParkingCenterService: ApiParkingCenterService,
    private cookieService: CookieService,
    private langService: LanguageService,
    private router: Router,
    private toast: ToastNotifService,
    private apiSitePublic: ApiSitePublicService
  ) {

    this.langService.currentLang$.subscribe(lang => {
      this.currentLanguage = lang;
    });
  }


  async ngOnInit() {
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    this.isLoading = true;
    this.getParkingLocationsDetail()
    this.getPublicProfile();

  }

  /*-------------------------------------------- Modal slide --------------------------------------------*/
  // เริ่มสัมผัสหน้าจอ
  onTouchStart(event: TouchEvent) {
    // บันทึกตำแหน่งเริ่มต้นของนิ้ว
    this.dragStartY = event.touches[0].clientY;
    this.isDragging = true;
    this.modalTransition = 'none'; // ปิด animation ชั่วคราวเพื่อให้ขยับตามนิ้วทันที
  }

  // ขณะลากนิ้ว
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;

    const currentY = event.touches[0].clientY;
    const diff = currentY - this.dragStartY;

    // อนุญาตให้ลากลงเท่านั้น (diff > 0)
    if (diff > 0) {
      this.dragCurrentY = diff;
      // ขยับ Modal ตามนิ้วแบบ 1:1
      this.modalTransform = `translateY(${diff}px)`;
    }
  }

  // ปล่อยนิ้ว
  onTouchEnd() {
    this.isDragging = false;
    this.modalTransition = 'transform 0.3s ease-out'; // เปิด animation เพื่อดีดกลับหรือปิดนุ่มๆ

    // ถ้าลากลงมาเกิน 150px ให้ปิด Modal เลย
    if (this.dragCurrentY > 150) {
      this.modalTransform = `translateY(100%)`; // เลื่อนลงไปให้สุดจอ
      setTimeout(() => {
        this.close(); // เรียกฟังก์ชันปิดจริง
        // Reset ค่าเผื่อเปิดใหม่
        this.resetModalPosition();
      }, 300);
    } else {
      // ถ้าลากไม่ถึง ให้ดีดกลับที่เดิม
      this.resetModalPosition();
    }
  }

  resetModalPosition() {
    this.dragCurrentY = 0;
    this.modalTransform = '';
  }



  /* -------------------------------------------- Function -------------------------------------------- */
  /* -- style --*/
  selectNav(index: number) {
    this.activeIndex = index;

    if (index === 0) {
      // สมัครสมาชิก
      this.registerMember();
    } else if (index === 1) {
      // นำทาง
      this.googleMapNavigate();
    }
  }
  getFullStarArray(): boolean[] {
    const maxStars = 5;
    const oneStarValue = 55;
    const starCount = Math.min(maxStars, Math.ceil(this.rating / oneStarValue));
    return Array.from({ length: maxStars }, (_, i) => i < starCount);
  }

  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.isWarning = true;
    this.textWarn = text
    this.detailWarn = text//detail
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.isError = true;
    this.textError = text
    this.detailError = text//detail
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.isSuccess = true;
    this.textSuccess = text
    this.detailSuccess = text//detail
  }


  // รูปภาพ
  goToImage_building(index: number, event: Event) {
    event.stopPropagation(); // ป้องกันการปิด modal
    this.currentImageIndex_building = index;
  }
  goToImage_floor(index: number, event: Event) {
    event.stopPropagation(); // ป้องกันการปิด modal
    this.currentImageIndex_floor = index;
  }
  previousImage_building(event: Event) {
    event.stopPropagation(); // ป้องกันปิด modal
    if (!this.imageBuildingList || this.imageBuildingList.length === 0) return;
    this.currentImageIndex_building =
      (this.currentImageIndex_building - 1 + this.imageBuildingList.length) % this.imageBuildingList.length;
  }

  nextImage_building(event: Event) {
    event.stopPropagation(); // ป้องกันปิด modal
    if (!this.imageBuildingList || this.imageBuildingList.length === 0) return;
    this.currentImageIndex_building =
      (this.currentImageIndex_building + 1) % this.imageBuildingList.length;
  }
  previousImage_floor(event: Event) {
    event.stopPropagation(); // ป้องกันปิด modal
    if (!this.imageFloorList || this.imageFloorList.length === 0) return;
    this.currentImageIndex_floor =
      (this.currentImageIndex_floor - 1 + this.imageFloorList.length) % this.imageFloorList.length;
  }
  nextImage_floor(event: Event) {
    event.stopPropagation(); // ป้องกันปิด modal
    if (!this.imageFloorList || this.imageFloorList.length === 0) return;
    this.currentImageIndex_floor =
      (this.currentImageIndex_floor + 1) % this.imageFloorList.length;
  }

  // Modal
  openModalRecommend() {
    this.isModalRecommend = true;
  }
  closeModalRecommend() {
    this.isModalRecommend = false;
  }

  /* -- ฟังก์ชั่น --*/
  close() {
    this.closed.emit();
  }
  filterBuilding(index: number) {
    // เรียกข้อมูล
    this.selectBuilding = index;
    this.filteredBuildingList = this.listBuilding?.buildingInfo.filter(building => building.buildingId === index)[0];

    // กำหนดขข้อมูลเริ่มต้น
    const onlyZoneInfos = this.filteredBuildingList.floors.flatMap((floor: any) => floor.zoneInfos);
    const tableModel: { floor: number; carParking_available: number; evParking_available: number; motorcycleParking_available: number; }[] = [];

    /*----- Description -----
      parkingTypeID -> 1 = Car, 2 = Motorcycle , 3 = EV
      VehicleTypeID -> ยังไม่มี

    ----------------------- */
    /*----- Filter -------*/
    const carFilter = 1;
    const motorcycleFilter = 2;
    const evFilter = 3;
    /*----------------------- */

    // รวม parking ทั้งหมด
    this.allBuildingEvParking = onlyZoneInfos
      .filter((zone: any) => zone.parkingTypeId === evFilter)
      .reduce((acc: any, cur: { parkingSlot: any; }) => acc + cur.parkingSlot, 0);
    this.allBuildingCarParking = onlyZoneInfos
      .filter((zone: any) => zone.parkingTypeId === carFilter)
      .reduce((acc: any, cur: { parkingSlot: any; }) => acc + cur.parkingSlot, 0);
    this.allBuildingMotorcycleParking = onlyZoneInfos
      .filter((zone: any) => zone.parkingTypeId === motorcycleFilter)
      .reduce((acc: any, cur: { parkingSlot: any; }) => acc + cur.parkingSlot, 0);

    // --- สร้างข้อมูลรูปภาพชั้น ---
    const imageFloorCal = this.filteredBuildingList.floors
      .map((floor: any) => floor.imagesFloors)
      .reduce((acc: any[], curr: any[]) => acc.concat(curr), [])
      .filter((image: any) => image.imagesFloor !== null && image.imagesFloor !== undefined && image.imagesFloor !== '')
      .flatMap((image: any) => image.imagesFloor);

    // Table
    this.filteredBuildingList.floors.forEach((floor: any) => {
      // รวม parking ในแต่ละ zone
      var zoneCar = 0;
      var zoneMotorcycle = 0;
      var zoneEV = 0;
      onlyZoneInfos.forEach((zone: any) => {
        if (zone.parkingTypeId === 1) {
          zoneCar += zone.availableSlot;
        }
        if (zone.parkingTypeId === 2) {
          zoneMotorcycle += zone.availableSlot;
        }
        if (zone.parkingTypeId === 3) {
          zoneEV += zone.parkingSlot;
        }
      })
      // รวม parking ในแต่ละชั้น
      tableModel.push({
        floor: floor.floorName,
        carParking_available: zoneCar,
        evParking_available: zoneEV,
        motorcycleParking_available: zoneMotorcycle,
      });
    });

    this.tableBuildingParking = tableModel;

    // ใส่ข้อมูล
    this.imageFloorList = imageFloorCal;

    console.log("List all filter : ", this.filteredBuildingList, "tableBuildingParking", this.tableBuildingParking, "Select : ", this.selectBuilding, this.filteredBuildingList, "Image Floor : ", this.imageFloorList);
  }
  calculateParking() {
    // จำลองข้อมูล
    var car_available: { buildingId: number; parking: any; }[] = [];
    var motorcycle_available: { buildingId: number; parking: number }[] = [];
    var ev_available: { buildingId: number; parking: number }[] = [];

    var total_all = 0;
    var total_building: { buildingId: number; parking: any; }[] = [];

    var total_all_available = 0;
    var total_building_available: { buildingId: number; parking: any; }[] = [];

    /*----- Description -----
      parkingTypeID -> 1 = Car, 2 = Motorcycle , 3 = EV
      VehicleTypeID -> ยังไม่มี

    ----------------------- */
    /*----- Filter -------*/
    const carFilter = 1;
    const motorcycleFilter = 2;
    const evFilter = 3;
    /*----------------------- */

    // --- สร้างข้อมูลผลรวมต่างๆ ---
    this.listBuilding?.buildingInfo.forEach(element => {

      // --- สร้าง array ของ zoneInfos ทั้งหมด ---
      const onlyZoneInfos = element.floors.flatMap((floor: any) => floor.zoneInfos);

      // *** สร้างข้อมูลที่จอดไม่ว่าง ***
      const evParkingCal = onlyZoneInfos.filter((zone: any) => zone.parkingTypeId === evFilter).reduce((acc: any, cur: { parkingSlot: any; }) => acc + cur.parkingSlot, 0);
      const carParkingCal = onlyZoneInfos.filter((zone: any) => zone.parkingTypeId === carFilter).reduce((acc: any, cur: { parkingSlot: any; }) => acc + cur.parkingSlot, 0);
      const motorcycleParkingCal = onlyZoneInfos.filter((zone: any) => zone.parkingTypeId === motorcycleFilter).reduce((acc: any, cur: { parkingSlot: any; }) => acc + cur.parkingSlot, 0);
      //console.log("Test : ", element.floors.flatMap(floor => floor.zoneInfos).filter((zone : any) => zone.parkingTypeId === 1));
      // ใส่ข้อมูล
      total_all += evParkingCal + carParkingCal + motorcycleParkingCal;
      total_building.push({ buildingId: element.buildingId, parking: evParkingCal + carParkingCal + motorcycleParkingCal });

      // *** สร้างข้อมูลที่จอดว่าง ***
      const evParkingCal_available = onlyZoneInfos.filter((zone: any) => zone.parkingTypeId === evFilter).reduce((acc: any, cur: { availableSlot: any; }) => acc + cur.availableSlot, 0);
      const carParkingCal_available = onlyZoneInfos.filter((zone: any) => zone.parkingTypeId === carFilter).reduce((acc: any, cur: { availableSlot: any; }) => acc + cur.availableSlot, 0);
      const motorcycleParkingCal_available = onlyZoneInfos.filter((zone: any) => zone.parkingTypeId === motorcycleFilter).reduce((acc: any, cur: { availableSlot: any; }) => acc + cur.availableSlot, 0);
      // ใส่ข้อมูล
      car_available.push({ buildingId: element.buildingId, parking: carParkingCal_available }); // กรองข้อมูลที่จอดรถ
      motorcycle_available.push({ buildingId: element.buildingId, parking: motorcycleParkingCal_available });// กรองข้อมูลที่จอดมอเตอร์ไซค์
      ev_available.push({ buildingId: element.buildingId, parking: evParkingCal_available });// กรองข้อมูลที่จอด EV

      total_all_available += evParkingCal_available + carParkingCal_available + motorcycleParkingCal_available;// กรองข้อมูลที่จอดทั้งหมดทุกอาคาร
      total_building_available.push({ buildingId: element.buildingId, parking: evParkingCal_available + carParkingCal_available + motorcycleParkingCal_available });// กรองข้อมูลที่จอดที่ว่างทั้งหมดทุกอาคาร


    });

    // ใส่ข้อมูลของจริง ไปในตัวแปร
    this.carBuildingAvailable = car_available;
    this.motorcycleBuildingAvailable = motorcycle_available;
    this.evBuildingAvailable = ev_available;

    this.allBuildingsParking = total_all;
    this.allFloorsParking = total_building;

    this.allBuildingsParkingAvailable = total_all_available;
    this.allFloorsParkingAvailable = total_building_available;

    console.log("List all : ", this.listBuilding, "AllFloorsParking", this.allFloorsParking, "\nAllBuildingsParking", this.allBuildingsParking, "AllFloorsParkingAvailable", this.allFloorsParkingAvailable, "this.allBuildingsParkingAvailable", this.allBuildingsParkingAvailable);

  }

  calculateBuildingAvailable(buildingId: number) {
    let result = 0;
    this.carBuildingAvailable.forEach((item: { buildingId: number, parking: number }) => {
      if (buildingId === item.buildingId) {
        result += item.parking;
      }
    });
    this.motorcycleBuildingAvailable.forEach((item: { buildingId: number, parking: number }) => {
      if (buildingId === item.buildingId) {
        result += item.parking;
      }
    });
    this.evBuildingAvailable.forEach((item: { buildingId: number, parking: number }) => {
      if (buildingId === item.buildingId) {
        result += item.parking;
      }
    });
    return result;
  }

  // Navigate
  googleMapNavigate() {
    console.log("googleMapNavigate", this.position);
    const url = `https://www.google.com/maps/dir/?api=1&destination=${this.position.lat},${this.position.lng}&travelmode=driving`;
    window.open(url, '_blank');
  }
  registerMember() {
    this.isLoading = true;
    this.apiProviderService.getProviders().subscribe({
      next: (response: Providers[]) => {
        const foundProvider = response.find(
          (p: Providers) => p.name.trim() === this.listBuilding.name.trim()
        );

        if (foundProvider) {
          sessionStorage.setItem('providerId', foundProvider.id.toString());
          sessionStorage.setItem('providerName', foundProvider.name);
          this.router.navigate(['/register-member-vehicle'], {
            state: { providerId: foundProvider.id },
          });
        } else {
          this.showWarning(
            this.currentLanguage === 'TH'
              ? 'ไม่พบข้อมูลผู้ให้บริการนี้'
              : 'Provider not found'
          );
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
        this.showError(
          this.currentLanguage === 'TH'
            ? 'เกิดข้อผิดพลาดในการดึงข้อมูลผู้ให้บริการ'
            : 'Error fetching providers'
        );
      },
    });
  }

  private isPng(base64: string): boolean {
    return (
      base64.startsWith('data:image/png;base64,') ||
      base64.includes('image/png;base64') ||
      base64.startsWith('iVBORw0KGgo')
    );
  }

  private pngToJpeg(base64: string, quality: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Canvas not supported');
          return;
        }

        // พื้นหลังขาว (JPEG ไม่มี transparency)
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(img, 0, 0);

        const jpegBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(jpegBase64);
      };

      img.onerror = reject;

      img.src = base64.startsWith('data:')
        ? base64
        : `data:image/png;base64,${base64}`;
    });
  }


  /* -------------------------------------------- API -------------------------------------------- */
  async getParkingLocationsDetail() {
    this.apiParkingCenterService.ParkingLocationDetail(this.token, this.siteId).subscribe({
      next: (response) => {
        setTimeout(() => {
          if (response) {
            console.log("Parking Location Detail response : ", response);

            this.listBuilding = response;
            // this.rating = this.listBuilding.rating || 0;

            const rawImages = this.listBuilding.buildingInfo
              .flatMap((building: any) => building.imagesBuildings)
              .flatMap((imageArray: ImageBuildings) => imageArray.imagesBuilding)
              .filter((image: string) => image !== null && image !== undefined && image !== '');

            Promise.all(rawImages.map(image =>
              this.isPng(image) ? this.pngToJpeg(image, 0.9) : image
            )).then(results => {
              this.imageBuildingList = results;
              this.refreshHeroImages();
              console.log("Filter image building : ", this.imageBuildingList);
            });

            // Count parking slot all
            setTimeout(() => {
              this.calculateParking();
              this.isLoading = false;
            }, 1000);
          }
          else {
            this.isLoading = false;
            console.log("Parking Location response Not Found!");
          }

        }, 500);
      }, error: (err) => {
        setTimeout(() => {
          this.isLoading = false;
          console.error('โหลดข้อมูลล้มเหลว', err);
        }, 500);
      }
    });
  }

  /* -------------------------------------------- Public profile -------------------------------------------- */
  profile: SitePublicProfileDetail | null = null;
  heroImages: string[] = [];
  heroIndex = 0;
  isViewerOpen = false;
  viewerIndex = 0;

  /** โหลด profile การตลาด — ไม่มี ref / โหลดไม่ได้ → ใช้รูปอาคารเดิม */
  getPublicProfile() {
    if (!this.publicRef) return;
    this.apiSitePublic.getPublicParkingSiteDetail(this.publicRef).subscribe({
      next: (res) => {
        this.profile = res;
        this.refreshHeroImages();
      },
      error: (err) => {
        console.warn('getPublicParkingSiteDetail failed — fallback to building images', err);
        this.profile = null;
      },
    });
  }

  refreshHeroImages() {
    const fromProfile: string[] = [];
    if (this.profile?.coverImage) fromProfile.push(this.profile.coverImage);
    for (const img of this.profile?.images ?? []) {
      if (img.image) fromProfile.push(img.image);
    }
    this.heroImages = fromProfile.length ? fromProfile : [...(this.imageBuildingList ?? [])];
    this.heroIndex = Math.min(this.heroIndex, Math.max(0, this.heroImages.length - 1));
  }

  get profileSummary(): string {
    if (!this.profile) return '';
    if (this.currentLanguage === 'EN' && this.profile.summaryEn?.trim()) return this.profile.summaryEn;
    return this.profile.summaryTh || '';
  }

  onHeroScroll(event: Event) {
    const el = event.target as HTMLElement;
    if (!el.clientWidth) return;
    this.heroIndex = Math.round(el.scrollLeft / el.clientWidth);
  }

  openHeroViewer(index: number) {
    this.viewerIndex = index;
    this.isViewerOpen = true;
  }

  trackByUrl(_: number, url: string): string {
    return url;
  }

  goToSiteDetail() {
    if (!this.publicRef) return;
    const ref = this.publicRef;
    this.close();
    void this.router.navigate(['/lot', ref]);
  }

}
